<template>
  <b-row class="mt-2">
    <b-col>
      <b-card
        class="rounded-0"
        v-if="contactPersons && contactPersons.length !== 0">
        <h4>
          {{ $t('message.adminUserContactPerson.title') }}
        </h4>

        <b-table striped
                 responsive
                 :fields="fields"
                 :items="contactPersons"
                 tbody-class="text-muted">
          <template slot="dateOfBirth" slot-scope="row">
            {{ $moment(row.item.dateOfBirth, 'YYYY-MM-DD').format('DD.MM.YYYY') }}
          </template>
          <template slot="city" slot-scope="row">
            <span v-html="row.item.addresses.map(address => address.city).join(', <br>')"></span>
          </template>
          <template slot="postalCode" slot-scope="row">
            <span v-html="row.item.addresses.map(address => address.postalCode).join(', <br>')"></span>
          </template>
          <template slot="relation" slot-scope="row">
            {{ row.item.relationshipType? $t('enums.relationTypes.' + row.item.relationshipType) : null }}
          </template>
          <template slot="street" slot-scope="row">
            <span v-html="row.item.addresses.map(address => address.street).join(', <br>')"></span>

          </template>
          <template slot="streetNumber" slot-scope="row">
            <span v-html="row.item.addresses.map(address => address.streetNumber).join(', <br>')"></span>
          </template>
          <template slot="actions" slot-scope="row">
            <b-form-checkbox id="heirCheckbox"
                             v-model="row.item.heir"
                             @change="setHeirStatus($event, row.item.id)">
            </b-form-checkbox>
          </template>
        </b-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'AdminUserContactPerson',
    computed: {
      contactPersons () {
        return this.$store.getters.adminContactPersons
      }
    },
    data () {
      return {
        fields: [{
          key: 'firstName',
          label: this.$t('message.adminUserContactPerson.table.firstName')
        }, {
          key: 'lastName',
          label: this.$t('message.adminUserContactPerson.table.lastName')
        }, {
          key: 'email',
          label: this.$t('message.adminUserContactPerson.table.email')
        }, {
          key: 'relation',
          label: this.$t('message.adminUserContactPerson.table.relation')
        }, {
          key: 'dateOfBirth',
          label: this.$t('message.adminUserContactPerson.table.dateOfBirth')
        }, {
          key: 'city',
          label: this.$t('message.adminUserContactPerson.table.city')
        }, {
          key: 'street',
          label: this.$t('message.adminUserContactPerson.table.street')
        }, {
          key: 'streetNumber',
          label: this.$t('message.adminUserContactPerson.table.streetNumber')
        }, {
          key: 'postalCode',
          label: this.$t('message.adminUserContactPerson.table.postalCode')
        }, {
          key: 'actions',
          label: this.$t('message.adminUserContactPerson.table.heir')
        }]
      }
    },
    methods: {
      setHeirStatus (event, contactPersonId) {
        this.$store.dispatch('setHeirStatus', {
          phId: parseInt(this.$route.params.id),
          isCertificateOfInheritanceApproved: event,
          isEntitledInCertificateOfInheritance: event,
          contactPersonId: contactPersonId
        })
          .then(() => {
            this.contactPersons.filter(contactPerson => contactPerson.id === contactPersonId)[0].heir = event
          })
          .catch(() => {
            this.contactPersons.filter(contactPerson => contactPerson.id === contactPersonId)[0].heir = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminUserContactPerson.vue